import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

import { CardObjectType, FilterRequest, Response } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class CardObjectTypeService {
  constructor(private http: HttpClient) { }

  list(request?: FilterRequest): Observable<Response<CardObjectType[]>> {
    return this.http.post<Response<CardObjectType[]>>(environment.apiUrl + '/api/CardObjectType/List', request);
  }

}
